<template>
  <div class="content">
    <div id="login"></div>
  </div>
</template>

<script>
// import WX from "wx";
import wxLogin from "@/assets/js/wxLogin.js";

export default {
  data() {
    return {};
  },
  created() {
    this.makerCode();
  },
  methods: {
    makerCode() {
      const redirectUri = "http://your-redirect-uri"; // 设置回调地址
      const scope = "snsapi_login"; // 授权作用域，可以根据需求选择 snsapi_base 或 snsapi_userinfo

      const obj = new wxLogin({
        self_redirect: true,
        id: "login",
        appid: "",
        scope: scope,
        redirect_uri: redirectUri,
        state: "",
        style: "",
        href: ""
      });

      // const obj = new wxLogin({
      //   self_redirect: false,
      //   id: "your-login-container", // 登录容器的 DOM 元素 ID
      //   appid: "your-appid", // 你的应用 appid
      //   scope: scope,
      //   redirect_uri: redirectUri,
      //   state: "your-state",
      //   style: ""
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  height: 970px;
  background-image: url("http://static.smallschoolbag.com/static/noten/website/creation/login.png");
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue